import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useDispatch } from 'react-redux';
import { setIndustries as setSliceIndustries } from '../features/application/applicationSlice';
import type { Industry } from '../types/types';

export const useIndustries = () => {
  const [industries, setIndustries] = useState<Industry[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchIndustries = async () => {
      setLoading(true);
      setError(null);

      // const { data, error }: PostgrestResponse<Industry> = await supabase
      //   .from('industries')
      //   .select('*')
      //   .eq('country_code', countryCode)
      //   .order('industry_name', { ascending: true });

      const { data, error } = await supabase
        .from('industry_options')
        .select('id, label, score, ordinal')
        .order('ordinal', { ascending: true });

      if (error) {
        console.error('Error fetching industries:', error);
        setIndustries([]);
        setError(error.message);
      } else {
        setIndustries(data ?? []);
        dispatch(setSliceIndustries(data ?? []));
      }

      setLoading(false);
    };

    fetchIndustries();
  }, []);

  return { industries, loading, error };
};
